// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const enterpriseClient = createTypedClient();
export const createEnterpriseClient = (config) => createTypedClient(config);
